import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, Observable, forkJoin } from "rxjs";
import { PlanDTO } from "src/app/data/schema/Billing/Plans/PlanDTO";
import { ApiBillingPlanService } from "src/app/data/service/billing/api-billing-plan.service";
import enUS from "./i18n/en-US.json";
import esES from "./i18n/es-ES.json";
import ptBR from "./i18n/pt-BR.json";

export interface purchaseMethodsDialogData {
    fixedPrice: number;
    courseId: string;
    planIds: Array<string>;
    title: string;
    subscriptionId: string;
    customMessage: string;
    isCertificate?: boolean;
}

@Component({
    selector: "app-presentation-purchase-methods",
    templateUrl: "./presentation-purchase-methods.component.html",
    styleUrls: ["./presentation-purchase-methods.component.scss"]
})
export class PresentationPurchaseMethodsComponent implements OnInit {
    public plans$: BehaviorSubject<Array<PlanDTO>>;

    constructor(
        private translate: TranslateService,
        private _apiBillingPlanService: ApiBillingPlanService,
        private dialogRef: MatDialogRef<PresentationPurchaseMethodsComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: purchaseMethodsDialogData
    ) {
        this.translate.setTranslation("pt-BR", ptBR, true);
        this.translate.setTranslation("en-US", enUS, true);
        this.translate.setTranslation("es-ES", esES, true);

        this.plans$ = new BehaviorSubject<Array<PlanDTO>>([]);
    }

    ngOnInit(): void {
        this.plans$.next([]);

        if (this.data.planIds?.length > 0) this.getPlans(this.data.planIds, this.data.subscriptionId);
    }

    public getPlans(planIds: Array<string>, subscriptionId: string): void {
        const requests: Array<Observable<PlanDTO>> = [];

        planIds.forEach((planId) => {
            requests.push(this._apiBillingPlanService.get(planId, subscriptionId));
        });

        forkJoin(requests).subscribe((plans) => {
            this.plans$.next(plans.filter((p) => p.active));
        });
    }

    public close(): void {
        this.dialogRef.close();
    }
}
